import api from "../../axiosConfig";

export const addpatient = async (formData) => {
    try {

      const response = await api.post('/patient/add-patient', formData);
      const resData = response?.data;
      console.log('Response data:', resData);
  
      if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
        return { success: true, data: resData?.data };
      } else {
        return { success: false, error: resData.message };
      }
    } catch (err) {
      throw new Error(err.response?.data?.message || 'Login error');
    }
  };

  export const getPatientList = async (searchKeyword) => {
  const token = sessionStorage.getItem('token');

  try {
    const response = await api.get('/patient/all-patient', {
        params:{
          search_keyword:searchKeyword
        }
    });

    const resData = response?.data;
    console.log('Response data:', resData);

    if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
      return { success: true, data: resData?.data };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error fetching patients');
  }
};



export const updatePatient = async (id, formData) => {
  const token = sessionStorage.getItem('token');

  // Append required format values
  const payload = {
    ...formData,
    id: id,
    _method: 'put', // Required for Laravel-style method spoofing
  };
  console.log('Payload for update:', payload);

  try {
    const response = await api.post(`/patient/update-patient/${id}`, payload, {
     
    });

    const resData = response?.data;
    console.log('Update patient response:', resData);

    if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
      return { success: true, data: resData?.data };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error updating patients');
  }
};